import React, { useState } from 'react';
import ConfirmationModal from '../Components/ConfirmationModal';

const useModal = () => {
  const [openModal, setOpenModal] = useState(false);

  const modal = ({ acceptText = '', onAccept = () => {}, isDraft }) => (
    <ConfirmationModal
      isDraft={isDraft}
      acceptText={acceptText}
      close={() => {
        setOpenModal(!openModal);
      }}
      open={openModal}
      onAccept={onAccept}
    />
  );

  return {
    ConfirmationModal: modal,
    openModal,
    setOpenModal,
  };
};

export default useModal;
